import { ProgressIndicatorService } from "./progress-indicator.service";

export const SERVICE_PROVIDERS = [
    ProgressIndicatorService
];
